import React from 'react';
import Scrollbars from 'react-custom-scrollbars';

import { ORDER_DETAILED_STATUS } from '../../../types';
import OrderDetailedItem from '../order-detailed-item/order-detailed-item';
import { OrderDetailedItemProps } from '../types';

import './order-detailed-list.scss';

interface OrderDetailedListProps {
  data: OrderDetailedItemProps[];
  onItemClick: (id: number, type: ORDER_DETAILED_STATUS) => void;
  selected: number[];
  goDetailedPosition: (id: number, itemId: number) => void;
  orderId: number;
  isInitiator: boolean;
}

const OrderDetailedList: React.FC<OrderDetailedListProps> = ({
  data,
  isInitiator,
  onItemClick,
  orderId,
  goDetailedPosition,
  selected,
}) => (
  <Scrollbars autoHide>
    <ul className="order__list">
      {/* eslint-disable-next-line react/jsx-props-no-spreading,jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
      {data.map((item) => (
        <li key={item.id} className="order__item">
          <OrderDetailedItem
            isInitiator={isInitiator}
            orderId={orderId}
            goDetailedPosition={goDetailedPosition}
            onItemClick={() => onItemClick(item.id, item.positionStatus)}
            selected={selected.indexOf(item.id) !== -1}
            {...item}
          />
        </li>
      ))}
    </ul>
  </Scrollbars>
);

export default OrderDetailedList;
